import { render, staticRenderFns } from "./OrganizerPlaceholder.vue?vue&type=template&id=04987bfb&scoped=true&"
import script from "./OrganizerPlaceholder.vue?vue&type=script&lang=js&"
export * from "./OrganizerPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04987bfb",
  null
  
)

export default component.exports